import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo-gray.svg';

const _withScopeId = n => (_pushScopeId("data-v-1920de4f"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer-container text-white mx-auto"
};

const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"me-2\" data-v-1920de4f><span class=\"font-h6 fs-lg\" data-v-1920de4f>本專案由</span></div><div class=\"logo-wrapper tablet-hidden me-2 d-flex align-items-center\" data-v-1920de4f><img src=\"" + _imports_0 + "\" alt=\"investNFT\" data-v-1920de4f></div><div data-v-1920de4f><span class=\"font-h6 fs-lg\" data-v-1920de4f>執行</span></div><div class=\"gray-60 mx-auto text-start font-h6 fs-lg\" data-v-1920de4f><div data-v-1920de4f>服務時間：週一至週五 上午 10:00 ～ 下午 18:00（假日與國定假日暫不提供服務）</div><div data-v-1920de4f>InvestNFT 服務專線：(02) 8101-2088</div></div>", 4);

const _hoisted_6 = /*#__PURE__*/_createTextVNode("元富活動網站");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_button_link = _resolveComponent("button-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_button_link, null, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  })]);
}